import React from 'react';

const WebDev = () => (
  <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4 py-0 animate__animated animate__fadeIn">
    {/* Hero Section */}
    <section className="w-full flex flex-col items-center justify-center py-16 sm:py-24 bg-gradient-to-br from-[#f8fafc] to-[#e8f5e9]">
      <div className="max-w-2xl w-full text-center">
        <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">Own Your Website Today</h1>
        <p className="text-lg sm:text-xl text-gray-700 mb-8">No monthly fees. No templates. Just beautifully branded sites that grow with your business.</p>
                        <a href="mailto:theimaginexcompany@gmail.com" className="inline-block px-8 py-4 bg-[#618A3D] text-white font-bold rounded-lg shadow-lg hover:bg-[#75a64b] transition text-lg">Get Your Custom Site Quote</a>
      </div>
    </section>

    {/* The Problem Section */}
    <section className="w-full max-w-3xl mx-auto py-12 sm:py-16 px-2 text-center">
      <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">Why are you still paying $15–$50/month for a basic website?</h2>
      <p className="text-lg text-gray-700 mb-2">In an AI-powered world, your site should be beautiful, affordable, and scalable—with no recurring hosting fees.</p>
    </section>

    {/* Our Solution Section */}
    <section className="w-full max-w-4xl mx-auto py-12 sm:py-16 px-2 flex flex-col md:flex-row gap-10 items-center">
      <div className="flex-1 text-center md:text-left">
        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Our Solution</h3>
        <p className="text-gray-700 mb-6">Imaginex builds custom, one-time-cost websites with included branding, deployment, and technical setup. Built once. Owned forever.</p>
        <ul className="mb-6 space-y-3 text-left inline-block">
          <li className="flex items-center text-base sm:text-lg"><span className="text-[#618A3D] text-xl mr-2">✦</span> Custom Design & Development</li>
          <li className="flex items-center text-base sm:text-lg"><span className="text-[#618A3D] text-xl mr-2">✦</span> No Monthly Hosting Fees</li>
          <li className="flex items-center text-base sm:text-lg"><span className="text-[#618A3D] text-xl mr-2">✦</span> Email & Github Setup Included</li>
          <li className="flex items-center text-base sm:text-lg"><span className="text-[#618A3D] text-xl mr-2">✦</span> Style Guide for Brand Consistency</li>
        </ul>
        <div className="bg-[#f8fafc] border-l-4 border-[#618A3D] px-4 py-2 rounded mb-4 max-w-xs md:max-w-sm text-left text-sm text-gray-700">
          <span className="font-semibold text-[#618A3D]">Add-ons:</span> Blogs and Storefront features are available upon request.
        </div>
      </div>
      {/* Timeline Section */}
      <div className="flex-1 bg-white rounded-xl shadow-lg p-6 md:p-8">
        <h4 className="text-lg font-bold text-gray-900 mb-4 text-center md:text-left">Timeline</h4>
        <ol className="list-decimal list-inside space-y-3 text-gray-700 text-left">
          <li><span className="font-semibold text-[#618A3D]">Intro Meeting + Brand Research</span></li>
          <li><span className="font-semibold text-[#618A3D]">Custom Wireframe + Design</span></li>
          <li><span className="font-semibold text-[#618A3D]">Full Stack Development & Launch</span></li>
          <li><span className="font-semibold text-[#618A3D]">Final Offboarding + Ownership Transfer</span></li>
        </ol>
      </div>
    </section>

    {/* Bonus Section */}
    <section className="w-full max-w-3xl mx-auto py-10 px-2 text-center">
      <div className="bg-[#f1f8e9] rounded-xl shadow p-6 sm:p-10">
        <h4 className="text-xl font-bold text-gray-900 mb-4">Bonus</h4>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 mb-4">
          <div className="flex flex-col items-center">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#e8f5e9] mb-2">
              {/* Email Icon */}
              <svg className="w-7 h-7 text-[#618A3D]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
            </div>
            <span className="font-semibold text-gray-900">Marketing Email</span>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#e8f5e9] mb-2">
              {/* GitHub Icon */}
              <svg className="w-7 h-7 text-[#618A3D]" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.477 2 2 6.484 2 12.021c0 4.428 2.865 8.184 6.839 9.504.5.092.682-.217.682-.482 0-.237-.009-.868-.014-1.703-2.782.605-3.369-1.342-3.369-1.342-.454-1.157-1.11-1.465-1.11-1.465-.908-.62.069-.608.069-.608 1.004.07 1.532 1.032 1.532 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.339-2.221-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.025A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.295 2.748-1.025 2.748-1.025.546 1.378.202 2.397.1 2.65.64.7 1.028 1.595 1.028 2.688 0 3.847-2.337 4.695-4.566 4.944.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.744 0 .267.18.577.688.48C19.138 20.2 22 16.448 22 12.021 22 6.484 17.523 2 12 2z" /></svg>
            </div>
            <span className="font-semibold text-gray-900">Branded GitHub</span>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#e8f5e9] mb-2">
              {/* Style Guide Icon */}
              <svg className="w-7 h-7 text-[#618A3D]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M9 9h6v6H9z" /></svg>
            </div>
            <span className="font-semibold text-gray-900">Style Guide</span>
          </div>
        </div>
        <p className="text-gray-700 text-base sm:text-lg">Get a marketing email, branded GitHub account, and a visual style guide that ensures brand consistency across platforms.</p>
      </div>
    </section>

    {/* Final CTA Section */}
    <section className="w-full flex flex-col items-center justify-center py-12 sm:py-16">
      <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 text-center">Ready to stop renting your website? Let’s build it right.</h3>
                      <a href="mailto:theimaginexcompany@gmail.com" className="inline-block px-8 py-4 bg-[#618A3D] text-white font-bold rounded-lg shadow-lg hover:bg-[#75a64b] transition text-lg">Book Your Discovery Call</a>
    </section>
  </div>
);

export default WebDev; 